import { render } from "./DetailAddGroupButton.vue?vue&type=template&id=11dd5d28&scoped=true"
import script from "./DetailAddGroupButton.vue?vue&type=script&lang=js"
export * from "./DetailAddGroupButton.vue?vue&type=script&lang=js"

import "./DetailAddGroupButton.vue?vue&type=style&index=0&id=11dd5d28&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11dd5d28"]])

export default __exports__